import {
  DTCreativeNode,
  DTNativeCreativeNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {creativeCardToText} from './creativeCardToText';

export function nativeCreativeCardToText(
  card: DTNativeCreativeNode,
  mode: 'short' | 'full',
): string {
  return creativeCardToText(card as unknown as DTCreativeNode, mode);
}
